import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import JsonLd from "@/components/feature/JsonLd";
import { buildWebsiteSchema, buildOrganizationSchema } from "@/lib/seo";


function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <JsonLd data={[buildWebsiteSchema(), buildOrganizationSchema()]} />
      <BrowserRouter basename={__BASE_PATH__}>
        <AppRoutes />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;